var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('router-link',{attrs:{"to":_vm.link}},[_c('img',{staticClass:"header-nav-item-image",attrs:{"src":_vm.imgSrc,"alt":_vm.label}}),_c('span',{staticClass:"navLinkText"},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }